module.exports = __webpack_public_path__ + "media/images/landing/logo-41a2386e50496656d077a3b15317feb1.svg";